import { render, staticRenderFns } from "./VideoCallHangupInner.vue?vue&type=template&id=128a5a12&"
import script from "./VideoCallHangupInner.vue?vue&type=script&lang=ts&"
export * from "./VideoCallHangupInner.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallHangupInner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports